import React, { Component } from 'react';
import AwardDetails from '../components/awardsDetails'

class ExhibitionAwards extends Component {
    render() {
        return (
            <div className='container'>
                <h1>Exhibition Awards 2024</h1>

                <AwardDetails />
            </div>
        );
    }
} 

export default ExhibitionAwards; 


// WEBPACK FOOTER //
// ./src/pages/exhibitionAwards.jsx